module.exports = __webpack_public_path__ + "media/images/flags/16/New-Zealand-3286206193b99e4c5d2b69d68fb6c3b8.png";